import React__default from 'react';
import styled from 'styled-components';
import { CSSGenerateFlexAlign } from '../styles/cssGenerate.js';
import { Hidden } from './Hidden.js';

const StackWrapper = styled.div`
  position: relative;
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  ${(props)=>props.height === "fill" && "height: 100%;"}
  ${(props)=>props.align ? CSSGenerateFlexAlign(props.align) : ""}
  text-align: ${(props)=>props.align};

  /* use double & to 'double up' the class that is generated i.e. .stack-class.stack-class  */
  /* this overrides simple selectors in specificity - e.g. .heading-class - no matter */
  /* their order in the css. */
  && > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  && > * + * {
    margin-top: ${(props)=>props.gap}rem;
  }

  /* Hidden elements should not count towards stack spacing calculations */
  && > [${Hidden.dataId}-is-hidden] + * {
    margin-top: 0;
  }
`;
/**
 * Layout component for creating vertical layouts.
 * Acts directly on child elements.
 *
 * @param gap - gap in `rem` units
 * @param align - horizontal alignment
 *
 * @example
 * // simple usage
 * <Stack>
 *  <SomeChildElement />
 *  <SomeChildElement />
 *  <SomeChildElement />
 * </Stack>
 *
 * // with gap (gutter between items)
 * <Stack gap={1.5}>
 *  <SomeChildElement />
 *  <SomeChildElement />
 *  <SomeChildElement />
 * </Stack>
 */ const Stack = ({ as , children , ...props })=>{
    return React__default.createElement(StackWrapper, {
        "data-hpy-web-stack": true,
        ...props,
        forwardedAs: as
    }, children);
};
Stack.dataId = "data-hpy-web-stack";
Stack.displayName = "Stack";

export { Stack };
